import React, { useCallback, useEffect, useState } from "react";
import i18n from "utils/i18n";
import ThemedSafeAreaComponentTop from "components/atoms/ThemedSafeAreaTop";
import ThemedLayout from "components/atoms/ThemedLayout";
import { useShowHamburger } from 'utils/helper-device'
import _ from 'lodash'
import { useNavigation, useRoute } from '@react-navigation/native'
import { createTranslationField, retrieveTranslationFields } from 'components/molecules/Form'
import { FormStatus } from 'utils/constants/form-constants';
import LoadingComponent from 'components/atoms/Loading'
import GraphqlBuilder, { graphqlOptions } from 'utils/request/graphql/builder'
import MutateTranslation from 'utils/mutate/translation'
import { constantsActive, tableConstants } from 'utils/constants/constants'
import { AppRoutes } from 'navigations/app-routes'
import MutationManagementTimeslotGroup from 'graphql/mutations/management/MutationManagementTimeslotGroup'
import HelperString from 'utils/helper-string'
import TabbedContent from 'components/molecules/TabbedContent'
import Translate from 'utils/translate'
import { useSelector } from 'react-redux'
import { dataConstants } from 'services/redux/data/constants'
import ManagementTimeslotGroupBasicTab from 'scenes/management/timeslots/timeslot_group/_tabs/Basic'
import FetchTimeslotGroups from 'utils/fetch/FetchTimeslotGroups'
import ManagementTimeslotGroupAdvancedTab from 'scenes/management/timeslots/timeslot_group/_tabs/Advanced'
import ManagementTimeslotGroupTimeslotKindsTab from 'scenes/management/timeslots/timeslot_group/_tabs/TimeslotKinds'
import FetchCachedTimeslotGroups from 'utils/fetch/cached/FetchCachedTimeslotGroups'
import ManagementCreditBundlesIndex from "scenes/management/credit_bundles/_tabs/bundle";
import ManagementCreditBundlesQr from "scenes/management/credit_bundles/_tabs/qr";

const ManagementCreditBundleGroupScene = () => {

	const navigation = useNavigation();
	const showHamburger = useShowHamburger();
	const route = useRoute();
	
	const tabBarItems = [];
	tabBarItems.push({
		key: 'credit_bundle_group_basic',
		text: i18n.t('management:pages.credits.title'),
		scene: ( props ) => {
			return <ManagementCreditBundlesIndex />;
		}
	});
	tabBarItems.push({
		key: 'credit_bundle_group_qr',
		text: i18n.t('management:pages.qrcodes.index.title'),
		scene: ( props ) => {
			return <ManagementCreditBundlesQr />;
		}
	});
	
	return (
		<ThemedSafeAreaComponentTop
			top={ false }>
			
			<ThemedLayout
				title={ i18n.t( 'management:pages.credits.title') }
				topNavigation={true}
				topNavigationProps={{
					showHamburgerDrawer: showHamburger
				}}
				showBackButton={ true }>
				
				<TabbedContent
					items={ tabBarItems }
				/>
			</ThemedLayout>
		</ThemedSafeAreaComponentTop>
	);
}

export default ManagementCreditBundleGroupScene
